import { render, staticRenderFns } from "./commonNodeNav.vue?vue&type=template&id=12f69b94&scoped=true"
import script from "./commonNodeNav.vue?vue&type=script&lang=js"
export * from "./commonNodeNav.vue?vue&type=script&lang=js"
import style0 from "./commonNodeNav.vue?vue&type=style&index=0&id=12f69b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f69b94",
  null
  
)

export default component.exports